import { css } from 'styled-components';

export const gradientTextMixin = ({ color }: { color?: string } = {}) => css`
    color: ${color ? color : (props) => props.theme.palette.green};
`;
